export const blogCategories = [
  { id: 'todos', name: 'Todos os artigos' },
  { id: 'guias', name: 'Guias' },
  { id: 'dicas', name: 'Dicas' },
  { id: 'servicos', name: 'Serviços' },
  { id: 'educacao', name: 'Educação' },
  { id: 'equipamentos', name: 'Equipamentos' },
];

export const blogKeywordCluster = [
  'chopp sorocaba',
  'chope sorocaba',
  'chop sorocaba',
  'delivery de chopp em sorocaba',
  'entrega de chopp sorocaba',
  'disk chopp sorocaba',
  'disk chope sorocaba',
  'chop entrega sorocaba',
  'chope para eventos',
  'chopp para churrasco',
  'chope para churrasco',
  'aluguel de chopeira sorocaba',
];

export const blogPosts = [
  {
    id: 7,
    title: 'Chopp, chop ou chope? Qual é o jeito certo de escrever',
    slug: 'chopp-chop-ou-chope',
    category: 'educacao',
    author: 'Equipe Bierz',
    date: '18 de março de 2026',
    readTime: '4 min de leitura',
    image: '/blog/blog2.png',
    excerpt:
      'Descubra qual é a forma mais correta de escrever, por que chope e chop também aparecem no dia a dia e o que realmente importa na hora de pedir.',
    seoDescription:
      'Entenda se o correto é chopp, chop ou chope e veja por que essas variações aparecem tanto quando alguém procura chopp gelado, entrega e atendimento em Sorocaba.',
    keywords: [
      'chopp ou chope',
      'chopp ou chop',
      'como escreve chopp',
      'chop sorocaba',
      'chope sorocaba',
      'delivery de chopp em sorocaba',
      'disk chopp sorocaba',
      'disk chope sorocaba',
    ],
    cta: {
      title: 'Seja chopp, chop ou chope, a Bierz leva até você',
      description:
        'Você pede do jeito que preferir e a Bierz cuida do resto: entrega o chopp gelado, instala os equipamentos no local e depois faz a retirada para você aproveitar o evento sem preocupação.',
      buttonLabel: 'Pedir chopp agora',
    },
    sections: [
      {
        heading: 'Chopp, chop ou chope: qual é o jeito certo?',
        paragraphs: [
          'Se você já ficou na dúvida entre escrever chopp, chope ou até chop, saiba que isso é mais comum do que parece. Essas variações fazem parte do dia a dia dos brasileiros e aparecem tanto na fala quanto na escrita.',
          'Mas afinal, qual é o jeito certo? Em comunicações mais formais, cardápios, fachadas e materiais de marcas, a forma mais usada é chopp. Ainda assim, chope e chop continuam aparecendo bastante porque refletem a maneira como muitas pessoas falam no cotidiano.',
        ],
      },
      {
        heading: 'A forma mais correta é chopp',
        paragraphs: [
          'A grafia chopp, com dois p, é a forma mais reconhecida comercialmente e a que passa mais consistência para quem trabalha com o produto. É ela que normalmente aparece em materiais profissionais, menus e comunicação de empresas do setor.',
          'Isso não significa que chope ou chop estejam fora da realidade. Na prática, essas variações são facilmente compreendidas e remetem à mesma bebida, especialmente quando o contexto já está ligado a eventos, churrascos, bares ou delivery.',
        ],
      },
      {
        heading: 'Por que tanta gente fala chope ou chop',
        paragraphs: [
          'Boa parte dessa diferença vem da pronúncia. Dependendo da região, as pessoas tendem a falar chope com mais naturalidade, enquanto outras simplificam para chop. Quando essa fala vai para a escrita, a variação aparece.',
          'Por isso, é muito normal encontrar pessoas procurando de formas diferentes. No fim, independentemente da escrita, todo mundo está buscando a mesma experiência: um chopp bem gelado, servido da forma certa e pronto para aproveitar.',
        ],
      },
      {
        heading: 'No final, o que importa é pedir com praticidade',
        paragraphs: [
          'Para quem vai organizar um churrasco, aniversário ou confraternização, a maior dúvida não costuma ser apenas a escrita. O que pesa mesmo é saber se vai chegar gelado, se o equipamento será instalado corretamente e se o serviço vai funcionar sem dor de cabeça.',
          'É aí que a experiência fala mais alto. Seja chopp, chop ou chope, do jeito que você pedir, a Bierz vai entregar, instalar o equipamento e fazer a retirada depois. Assim você fica livre para curtir o momento com seus convidados.',
        ],
      },
    ],
  },
  {
    id: 6,
    title: 'Qual a diferença entre chopp e cerveja?',
    slug: 'diferenca-entre-chopp-e-cerveja',
    category: 'educacao',
    author: 'Equipe Bierz',
    date: '18 de março de 2026',
    readTime: '5 min de leitura',
    image: '/blog/blog1.png',
    excerpt:
      'Veja de forma simples a diferença entre chopp e cerveja, entenda o que é pasteurização e por que o chopp costuma ser tão valorizado em eventos e churrascos.',
    seoDescription:
      'Entenda a diferença entre chopp e cerveja, saiba o que é pasteurização e veja por que o chopp costuma ser a escolha ideal para churrascos, festas e eventos em Sorocaba.',
    keywords: [
      'diferença entre chopp e cerveja',
      'o que é pasteurização',
      'chopp ou cerveja',
      'chopp para churrasco',
      'chopp para eventos',
      'delivery de chopp em sorocaba',
      'chope sorocaba',
      'chop sorocaba',
    ],
    cta: {
      title: 'Vai fazer um evento? Receba o chopp gelado e pronto para servir',
      description:
        'Para churrascos, aniversários e confraternizações, a Bierz entrega o chopp, instala o equipamento no local e faz a retirada depois, deixando tudo mais prático e bonito para os seus convidados.',
      buttonLabel: 'Pedir chopp pelo WhatsApp',
    },
    sections: [
      {
        heading: 'Chopp e cerveja são parecidos, mas não são exatamente a mesma coisa',
        paragraphs: [
          'Chopp e cerveja têm a mesma base: água, malte, lúpulo e fermentação. À primeira vista, parecem iguais e, de fato, são bebidas muito próximas. Mas existe uma diferença importante na forma como cada uma é tratada até chegar ao consumo.',
          'Essa diferença acaba influenciando principalmente a experiência. Quando falamos de chopp, muita gente associa a bebida a frescor, serviço na hora e sensação de produto mais vivo. Já a cerveja costuma estar ligada a um processo pensado para ganhar mais estabilidade e circulação em larga escala.',
        ],
      },
      {
        heading: 'Onde está a principal diferença',
        paragraphs: [
          'A diferença mais conhecida entre chopp e cerveja está no processo de conservação. A cerveja que vai para o mercado normalmente passa por uma etapa chamada pasteurização. Já o chopp, em geral, não passa por esse mesmo caminho e costuma ser pensado para consumo mais fresco, direto do barril.',
          'Isso não transforma um em melhor do que o outro em qualquer situação. O que muda é a proposta. A cerveja costuma priorizar durabilidade e distribuição. O chopp costuma priorizar serviço imediato, presença no copo e experiência no momento do consumo.',
        ],
      },
      {
        heading: 'O que é pasteurização, de forma simples',
        paragraphs: [
          'Pasteurização é um processo em que a bebida passa por um aquecimento controlado por um curto período e depois é resfriada rapidamente. O objetivo é aumentar a durabilidade do produto e ajudar no armazenamento, transporte e venda por mais tempo.',
          'Muita gente imagina que pasteurização significa perda total de qualidade, mas não é isso. O ponto principal é que ela muda a forma de conservação da bebida. No caso do chopp, a proposta normalmente está mais ligada a menos processamento, mais frescor e consumo em um intervalo mais próximo da entrega e do serviço.',
        ],
      },
      {
        heading: 'Por que o chopp se destaca em eventos',
        paragraphs: [
          'Em churrascos, festas e confraternizações, o chopp costuma ser muito valorizado porque entrega uma experiência diferente. Ele sai na hora, bem gelado, com colarinho bonito e com aquela sensação de produto fresco que agrada bastante os convidados.',
          'Além disso, para grupos maiores, trabalhar com barril e equipamento costuma ser mais prático do que depender de muitas embalagens individuais. Isso ajuda na organização, deixa a apresentação mais bonita e cria uma experiência mais próxima de bar no próprio evento.',
        ],
      },
      {
        heading: 'Afinal, qual escolher?',
        paragraphs: [
          'No dia a dia, cerveja e chopp podem atender momentos diferentes sem problema. Mas quando o assunto é evento, aniversário ou churrasco, o chopp normalmente se destaca por unir praticidade, apresentação e experiência.',
          'Quem procura chopp para eventos geralmente quer mais do que bebida. Quer uma solução pronta para receber bem, servir com facilidade e deixar a ocasião mais especial do começo ao fim.',
        ],
      },
    ],
  },
  {
    id: 1,
    title: 'Guia Completo de Chopp em Sorocaba: como pedir certo para seu evento',
    slug: 'guia-chopp-sorocaba',
    category: 'guias',
    author: 'Equipe Bierz',
    date: '15 de março de 2026',
    readTime: '6 min de leitura',
    image: 'https://images.unsplash.com/photo-1535958636474-b021ee887b13?q=80&w=1920&auto=format&fit=crop',
    excerpt:
      'Entenda como escolher chopp em Sorocaba, calcular volume, definir estilos e acertar no delivery para churrascos, aniversários e eventos corporativos.',
    seoDescription:
      'Guia de chopp em Sorocaba com dicas para escolher estilo, quantidade, entrega e estrutura ideal para festas, churrascos e eventos.',
    keywords: [
      'chopp sorocaba',
      'chope sorocaba',
      'delivery de chopp em sorocaba',
      'chopp para churrasco',
      'chope para eventos',
      'disk chopp sorocaba',
      'chop entrega sorocaba',
    ],
    cta: {
      title: 'Quer pedir chopp com segurança para o seu evento?',
      description:
        'A Bierz ajuda você a escolher a quantidade, entrega o chopp gelado, instala o equipamento e faz a retirada depois para o seu evento acontecer com praticidade.',
      buttonLabel: 'Falar com a Bierz no WhatsApp',
    },
    sections: [],
  },
  {
    id: 2,
    title: 'Chope para eventos: como servir bem em festas, aniversários e confraternizações',
    slug: 'chope-para-eventos',
    category: 'dicas',
    author: 'Equipe Bierz',
    date: '12 de março de 2026',
    readTime: '5 min de leitura',
    image: 'https://images.unsplash.com/photo-1470337458703-46ad1756a187?q=80&w=1920&auto=format&fit=crop',
    excerpt:
      'Veja como acertar no chope para eventos com temperatura correta, ponto de serviço, tipo de copo e estrutura ideal para receber seus convidados.',
    seoDescription:
      'Dicas práticas para servir chope em eventos com boa temperatura, estrutura certa e apresentação profissional em Sorocaba.',
    keywords: [
      'chope para eventos',
      'chope para churrasco',
      'delivery de chopp',
      'chope sorocaba',
      'disk chope sorocaba',
      'chopp sorocaba',
    ],
    cta: {
      title: 'Seu evento merece chope bem servido do começo ao fim',
      description:
        'Com a Bierz, você recebe o chopp gelado, a estrutura pronta para servir e o suporte ideal para deixar a experiência mais bonita para os convidados.',
      buttonLabel: 'Pedir chope para evento',
    },
    sections: [],
  },
  {
    id: 3,
    title: 'Disk chopp Sorocaba: como funciona a entrega e o suporte técnico',
    slug: 'disk-chopp-sorocaba',
    category: 'servicos',
    author: 'Equipe Bierz',
    date: '10 de março de 2026',
    readTime: '4 min de leitura',
    image: 'https://images.unsplash.com/photo-1566633806327-68e152aaf26d?q=80&w=1920&auto=format&fit=crop',
    excerpt:
      'Entenda como funciona o disk chopp em Sorocaba, prazos de entrega, montagem da chopeira e o que fazer se precisar de suporte durante seu evento.',
    seoDescription:
      'Saiba como funciona o disk chopp em Sorocaba com detalhes sobre entrega, montagem e suporte técnico para eventos e festas.',
    keywords: [
      'disk chopp sorocaba',
      'entrega de chopp sorocaba',
      'suporte chopp sorocaba',
      'delivery de chopp',
      'chope sorocaba',
      'chop sorocaba',
    ],
    cta: {
      title: 'Precisa de disk chopp com entrega e montagem?',
      description:
        'A Bierz leva o chopp até você, instala o equipamento no local e organiza a retirada depois para deixar seu evento mais simples e bem atendido.',
      buttonLabel: 'Solicitar disk chopp',
    },
    sections: [],
  },
  {
    id: 4,
    title: 'Tipos de chopp: pilsen, IPA, weiss e stout. Qual escolher?',
    slug: 'tipos-de-chopp',
    category: 'educacao',
    author: 'Equipe Bierz',
    date: '08 de março de 2026',
    readTime: '7 min de leitura',
    image: 'https://images.unsplash.com/photo-1532634733-cae13c563b00?q=80&w=1920&auto=format&fit=crop',
    excerpt:
      'Conheça os principais estilos de chopp e descubra qual combina mais com seu gosto e com o tipo de comida que você pretende servir no seu evento.',
    seoDescription:
      'Conheça os estilos de chopp pilsen, IPA, weiss e stout e saiba como escolher o melhor para seu evento em Sorocaba.',
    keywords: [
      'tipos de chopp',
      'chopp pilsen',
      'chopp ipa',
      'estilos de chopp',
      'chope sorocaba',
      'chopp para churrasco',
    ],
    cta: {
      title: 'Já sabe o estilo que quer servir no evento?',
      description:
        'A Bierz ajuda você a escolher o chopp ideal e entrega tudo pronto para servir com praticidade em churrascos, festas e confraternizações.',
      buttonLabel: 'Escolher meu chopp',
    },
    sections: [],
  },
  {
    id: 5,
    title: 'Equipamentos para servir chopp: o que você precisa saber',
    slug: 'equipamentos-para-servir-chopp',
    category: 'equipamentos',
    author: 'Equipe Bierz',
    date: '05 de março de 2026',
    readTime: '5 min de leitura',
    image: 'https://images.unsplash.com/photo-1518176258769-f227c798150e?q=80&w=1920&auto=format&fit=crop',
    excerpt:
      'Veja quais equipamentos importam para servir um chopp de qualidade: chopeiras elétricas, a gelo, cilindros de CO2 e a importância da limpeza.',
    seoDescription:
      'Saiba tudo sobre equipamentos para servir chopp em Sorocaba, de chopeiras elétricas a cilindros de CO2 e manutenção.',
    keywords: [
      'aluguel de chopeira sorocaba',
      'chopeira elétrica',
      'chopeira a gelo',
      'equipamentos para chopp',
      'disk chopp sorocaba',
    ],
    cta: {
      title: 'Quer receber o chopp com equipamento instalado?',
      description:
        'A Bierz entrega o barril, instala a estrutura no local e faz a retirada depois, para você servir bem sem se preocupar com a parte técnica.',
      buttonLabel: 'Pedir com instalação',
    },
    sections: [],
  },
];

export const getBlogPostBySlug = (slug) => {
  return blogPosts.find((post) => post.slug === slug);
};

export const getRelatedPosts = (currentSlug, category, limit = 3) => {
  const sameCategoryPosts = blogPosts.filter(
    (post) => post.slug !== currentSlug && (!category || post.category === category)
  );

  if (sameCategoryPosts.length >= limit) {
    return sameCategoryPosts.slice(0, limit);
  }

  const fallbackPosts = blogPosts.filter(
    (post) => post.slug !== currentSlug && !sameCategoryPosts.some((item) => item.slug === post.slug)
  );

  return [...sameCategoryPosts, ...fallbackPosts].slice(0, limit);
};
